import React, { Component } from "react";

import axios from "axios";
// import { AuthConsumer } from './AuthContext'
import { Input, Button, Container, Row, Col, Card, CardBody } from "mdbreact";
import domain from "./domain";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: " syam",
      course_id: null,
      data: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  componentDidMount() {
    console.log("here");
    axios
      .get(`${domain.DBServer}/fetch-course-status`)
      .then((result) => {
        console.log(result);
        this.setState({
          data: result.data,
          course_id: result.data[0].course_id,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  }
  onSubmit = (e) => {
    e.preventDefault();
    console.log(this.state.email);
    const data = {
      email: this.state.email,
      course_id: this.state.course_id,
    };

    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/send`,
        data: data,
      })
      .then((result) => {
        const { success, msg } = result.data;
        if (success === true) {
          alert(msg);
          this.props.history.replace(`/login`);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        alert(err);
      });
  };

  handleInputChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    console.log(value);
    this.setState({
      [name]: value,
    });
  }

  render() {
    let options;
    if (this.state.data) {
      options = this.state.data.map((course, key) => (
        <option key={course.course_id} value={course.course_id}>
          {course.title}
        </option>
      ));
    }

    return (
      <Container>
        <Row className="col-md-offset-5 col-centered">
          <Col md="12">
            <Card>
              <CardBody>
                <p className="h2 text-center mb-4">Forgot Password </p>
                <form onSubmit={this.onSubmit.bind(this)}>
                  <Input
                    label="Enter your email"
                    id="email"
                    name="email"
                    group
                    type="email"
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <div className="row">
                    <label for="course">Choose Course</label>
                    <select
                      className="form-control"
                      id="course_id"
                      name="course_id"
                      selected={this.state.course_id}
                      value={this.state.course_id}
                      onChange={this.handleInputChange}
                    >
                      {options}
                    </select>
                  </div>

                  <div className="text-center">
                    <Button className="btn btn-indigo" type="submit">
                      Submit
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default ForgotPassword;
